import React, { useContext, useEffect } from "react";
import { Button } from "@material-ui/core";
import { NavHashLink as NavLink } from "react-router-hash-link";
import { makeStyles } from "@material-ui/core/styles";

import "./Landing.css";
import { ThemeContext } from "../../contexts/ThemeContext";
import { headerData } from "../../data/headerData";
import { socialsData } from "../../data/socialsData";
import myImg from "../../assets/png/myImg.jpg";
import Typewriter from "typewriter-effect";
import gsap from "gsap";
import { LanguageContext } from "../../contexts/LanguageContext"; 
import profile from '../../assets/png/profile.jpg'
import profile2 from '../../assets/png/profile2.jpg'

import { FaLinkedin, FaGithub } from "react-icons/fa";

function Landing() {
  const { theme, drawerOpen } = useContext(ThemeContext);
  const { language } = useContext(LanguageContext); // Utilisation du LanguageContext pour obtenir la langue

  const useStyles = makeStyles((t) => ({
    resumeBtn: {
      color: theme.primary,
      borderRadius: "30px",
      textTransform: "inherit",
      textDecoration: "none",
      width: "150px",
      fontSize: "1rem",
      fontWeight: "500",
      height: "50px",
      fontFamily: "var(--primaryFont)",
      border: `3px solid ${theme.primary}`,
      transition: "100ms ease-out",
      "&:hover": {
        backgroundColor: theme.tertiary,
        color: theme.secondary,
        border: `3px solid ${theme.tertiary}`,
      },
      [t.breakpoints.down("sm")]: {
        width: "180px",
      },
    },
    contactBtn: {
      backgroundColor: theme.primary,
      color: theme.secondary,
      borderRadius: "30px",
      textTransform: "inherit",
      textDecoration: "none",
      width: "150px",
      height: "50px",
      fontSize: "1rem",
      fontWeight: "500",
      fontFamily: "var(--primaryFont)",
      border: `3px solid ${theme.primary}`,
      transition: "100ms ease-out",
      "&:hover": {
        backgroundColor: theme.secondary,
        color: theme.tertiary,
        border: `3px solid ${theme.tertiary}`,
      },
      [t.breakpoints.down("sm")]: {
        marginLeft: "10px",
      },
    },
  }));

  useEffect(() => {
    const tl = gsap.timeline();

    gsap.set(".landing--img", {
      opacity: 0,
    });

    tl.fromTo(
      ".landing--container-left",
      { x:-800, opacity: 0 },
      { x: 0, duration: 2.5, opacity: 1, ease: "power2.out" }
    ).fromTo(
      ".landing--img , .landing--container-right ",
      { scale: 1.5, opacity: 0 },
      { scale: 1, opacity: 1, duration: 1.5, ease: "power2.out" }
    );
  }, []);

  const classes = useStyles();

  // Fonction de traduction du headerData en fonction de la langue
  const getTranslation = (key) => {
    return headerData[key][language]; // Accès aux traductions en fonction de la langue
  };

  return (
    <div className="landing" style={{ margin: 0, padding: 0 }}>
      <div className="landing--container">
        <div
          className="landing--container-left"
          style={{ backgroundColor: theme.primary }}
        >
          <div className="lcl--content">
            {socialsData.linkedIn && (
              <a href={socialsData.linkedIn} target="_blank" rel="noreferrer">
                <FaLinkedin
                  className="landing--social"
                  style={{ color: theme.secondary }}
                  aria-label="LinkedIn"
                />
              </a>
            )}
            {socialsData.github && (
              <a href={socialsData.github} target="_blank" rel="noreferrer">
                <FaGithub
                  className="landing--social"
                  style={{ color: theme.secondary }}
                  aria-label="GitHub"
                />
              </a>
            )}
          </div>
        </div>
        <img
          src={profile}
          alt=""
          className="landing--img"
          style={{
            opacity: `${drawerOpen ? "0" : "1"}`,
            borderColor: theme.secondary,
          }}
        />
        <div className="landing--container-right">
          <div className="lcr--content" style={{ color: theme.tertiary }}>
            <h1 style={{ color: "black" }}>{getTranslation("name")}</h1>
            <h2 style={{ color: theme.primary }}>
              <Typewriter
                options={{
                  strings: getTranslation("title"), 
                  autoStart: true,
                  loop: true,
                }}
              />
            </h2>
            <p>{getTranslation("description")}</p>

            <div className="lcr-buttonContainer">
              {headerData.resumePdf && (
                <a
                  href={headerData.resumePdf}
                  download="Anas_Zerhoun_CV.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Button className={classes.resumeBtn}>
                    {language === "fr" ? "CV" : "Resume"}
                  </Button>
                </a>
              )}
              <NavLink
                to="/#contactMe"
                smooth={true}
                spy="true"
                duration={2000}
              >
                <Button className={classes.contactBtn}>
                  {language === "fr" ? "Contact" : "Contact"}
                </Button>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Landing;
